import styled from 'styled-components'
import theme from '../theme'

export const Container = styled.div`
  position: relative;
  padding: 15px 50px 15px 20px;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  max-width: 325px;

  border-radius: 5px;
  background-color: ${theme.palette.white};
  box-shadow: 0px 7px 19px 0px rgba(20, 37, 96, 0.15);

  font-weight: 400;
`

export const Icon = styled.svg`
  flex-shrink: 0;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`

export const Title = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.palette.black(20)};
`

export const CloseButton = styled.button`
  position: absolute;
  top: 17px;
  right: 15px;
  height: 16px;
  width: 16px;

  &:hover,
  &:active {
    background-color: transparent;
    border-color: transparent;
  }
`

export const Body = styled.div`
  margin-left: 26px;
`

export const Description = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 18px;
`
